<template>
    <div class="jc-steps-item" :class="{active: active === name}">
        <slot/>
    </div>
</template>

<script>
export default {
  name: 'jc-step',
  props: {
    name: { // 唯一标识
      type: [String, Number],
      required: true
    }
  },
  data () {
    return {
      parent: null,
      active: null
    }
  },
  methods: {
    updateStatus () {
      this.active = this.parent.currentValue
    }
  },
  mounted () {
    if (this.$parent) {
      this.parent = this.$parent
      this.parent.steps.push(this)
      // 更新状态
      this.updateStatus()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/step/step.vue